import { render } from "./TransferStoreOwnershipView.vue?vue&type=template&id=6f8b4f70&scoped=true"
import script from "./TransferStoreOwnershipView.vue?vue&type=script&lang=js"
export * from "./TransferStoreOwnershipView.vue?vue&type=script&lang=js"

import "./TransferStoreOwnershipView.vue?vue&type=style&index=0&id=6f8b4f70&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8b4f70"]])

export default __exports__